import React, { useReducer, createContext } from "react";

const initialState = {
  selectedItems: [],
  itemsCounter: 0,
  total: 0,
  checkout: false,
};
const sumItems=(items)=>{
  const itemsCounter=items.reduce((total,cources)=> total+cources.quantity,0);
  const total=items.reduce((totall,cources)=>totall+cources.cost*cources.quantity,0)
  return {itemsCounter,total}
  
}
// console.log(initialState.selectedItems)

const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD_ITEM":
        if (!state.selectedItems.find(item => item.id === action.payload._id)) {
            state.selectedItems.push({
                ...action.payload,
                quantity: 1
            })
        }
        return {
            ...state,
            selectedItems: [...state.selectedItems],
            ...sumItems(state.selectedItems),
            
            checkout:false,
        }
    case "REMOVE_ITEM":
      const newSelectedItems = state.selectedItems.filter(
        (item) => item._id !== action.payload._id
      );
      return {
        ...state,
        selectedItems: [...newSelectedItems],
        ...sumItems(newSelectedItems)
      };
    case "CLEAR":
      return {
        selectedItems: [],
        itemsCounter: 0,
        total: 0,
        checkout: false,
      };
    case "CHECKOUT":
      return {
        selectedItems: [],
        itemsCounter: 0,
        total: 0,
        checkout: true,
      };
    default:
      return state;
  }
};

export const CartContext = createContext();
const CartContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  return (
    <CartContext.Provider value={{ state, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};
export default CartContextProvider;
